import {useState, useRef, useEffect} from 'react'

interface UseScrollGradientsReturn {
  showTopGradient: boolean
  showBottomGradient: boolean
  scrollContainerRef: React.RefObject<HTMLDivElement>
}

/**
 * Custom hook to manage scroll gradients for scrollable containers
 * @param dependencies - Dependencies array for useEffect
 * @returns Object with gradient visibility states and container ref
 */
export const useScrollGradients = (
  dependencies: any[] = []
): UseScrollGradientsReturn => {
  const [showTopGradient, setShowTopGradient] = useState(false)
  const [showBottomGradient, setShowBottomGradient] = useState(false)
  const scrollContainerRef = useRef<HTMLDivElement | null>(null)

  const handleScrollGradients = () => {
    const container = scrollContainerRef.current
    if (!container) {
      return
    }

    const {scrollTop, scrollHeight, clientHeight} = container
    const isAtTop = scrollTop === 0
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1

    setShowTopGradient(!isAtTop)
    setShowBottomGradient(!isAtBottom)
  }

  useEffect(() => {
    const container = scrollContainerRef.current
    if (!container) {
      return
    }

    // Initial check
    handleScrollGradients()

    container.addEventListener('scroll', handleScrollGradients)
    return () => {
      container.removeEventListener('scroll', handleScrollGradients)
    }
  }, dependencies)

  return {
    showTopGradient,
    showBottomGradient,
    scrollContainerRef
  }
}
